import { graphql } from "../gql";

const getHeadToHeadPlayerPropsQuery = graphql(`
  query GetHeadToHeadPlayerProps($input: OddsMarketTypesInput!) {
    event(input: $input) {
      playerPropOdds {
        totalPassingYards {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          result {
            type
          }
          teamNumberFireId
          player {
            numberfireId
            name
            lastName
            jerseyNumber
            imageUrl
            position
            injury {
              injured
              description
              publishedAt
              status
            }
            teamInfo {
              logo {
                svg
              }
              name
              shortName
              teamJersey {
                svg
              }
            }
          }
          playerStat {
            value
            units
            period
          }
        }
        totalRushingYards {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          result {
            type
          }
          teamNumberFireId
          player {
            numberfireId
            name
            lastName
            jerseyNumber
            imageUrl
            position
            injury {
              injured
              description
              publishedAt
              status
            }
            teamInfo {
              logo {
                svg
              }
              name
              shortName
              teamJersey {
                svg
              }
            }
          }
          playerStat {
            value
            units
            period
          }
        }
        totalReceivingYards {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          result {
            type
          }
          teamNumberFireId
          player {
            numberfireId
            name
            lastName
            jerseyNumber
            imageUrl
            position
            injury {
              injured
              description
              publishedAt
              status
            }
            teamInfo {
              logo {
                svg
              }
              name
              shortName
              teamJersey {
                svg
              }
            }
          }
          playerStat {
            value
            units
            period
          }
        }
        totalPassingTDs {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          result {
            type
          }
          teamNumberFireId
          player {
            numberfireId
            name
            lastName
            jerseyNumber
            imageUrl
            position
            injury {
              injured
              description
              publishedAt
              status
            }
            teamInfo {
              logo {
                svg
              }
              name
              shortName
              teamJersey {
                svg
              }
            }
          }
          playerStat {
            value
            units
            period
          }
        }
      }
    }
  }
`);

export default getHeadToHeadPlayerPropsQuery;
